import * as Tags from './tags';
export function addDefaultNavigatorTags(span, navigator) {
    span.addTags({
        [Tags.NAVIGATOR_ONLINE]: navigator.onLine,
        [Tags.NAVIGATOR_USER_AGENT]: true,
    });
    span.log({ [Tags.NAVIGATOR_USER_AGENT]: navigator.userAgent });
}
//# sourceMappingURL=browser-helpers.js.map